import { MenuItem, Stack } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";

export const StyledStack = styled(Stack)`
  background-color: ${theme.palette.secondary.light};
  border-radius: 4px;
  box-shadow: 0 0 5px ${theme.palette.shadow.main};
  margin-top: 30px;
  width: 100%;
  padding: 20px;
  padding-top: 15px;
`;

export const StyledTitle = styled.div`
  width: 100%;
  padding: 10px;
  padding-bottom: 20px;
  border-bottom: 2px solid ${theme.palette.primary.main};
  margin-bottom: 20px;
  font-family: IRANSans;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.6;
  color: gray;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledMainReportCard = styled.div`
  @media (max-width: 600px) {
    font-size: 10px;
  }
`;
export const StyledTableContainer = styled.div`
  max-width: 100%;
  overflow-x: auto;
`;
export const StyledTable = styled.table`
  padding: 3px;
  border: 2px solid black;
  border-collapse: collapse;
  width: 100%;
  text-align: center;
`;
export const StyledTableBottom = styled.table`
  padding: 3px;
  border: 2px solid black;
  border-collapse: collapse;
  min-width: 55%;
  margin-top: 30px;
  text-align: center;
  @media (max-width: 400px) {
    width: 100%;
  }
`;
export const StyledTr = styled.tr`
  padding: 3px;
  border: 2px solid black;
  border-collapse: collapse;
`;
export const StyledTh = styled.th`
  padding: 3px;
  border: 2px solid black;
  border-collapse: collapse;
`;
export const StyledTd = styled.td`
  padding: 3px;
  border: 2px solid black;
  border-collapse: collapse;
`;

export const StyledMenuItem = styled(MenuItem)`
  text-align: right !important;
  direction: rtl;
`;
